import { render, staticRenderFns } from "./Avatares.vue?vue&type=template&id=c68688f0&"
import script from "./Avatares.vue?vue&type=script&lang=js&"
export * from "./Avatares.vue?vue&type=script&lang=js&"
import style0 from "./Avatares.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports